import { createBrowserRouter } from 'react-router-dom';
import { AccountWithFeatures } from '@cliengo/mfe-utils/types';

import { router, freeTrialEndedRouter, userHasDebtsRouter } from './appRouter';

export const routerFactory = (account: AccountWithFeatures) => {
  const isFreeCompany = account?.planType === 'CLIENGO_FREE';
  const userHasDebts = account?.hideLeads;

  if (userHasDebts) {
    return createBrowserRouter(userHasDebtsRouter);
  }
  if (isFreeCompany) {
    return createBrowserRouter(freeTrialEndedRouter);
  }
  return createBrowserRouter(router);
};
